export default __webpack_public_path__ + "static/media/bg_result_win.2ca61b33.png";